'use strict'

import wpapi from './wpapi'

let self

export default self = {
  container : document.querySelector('main#account'),
  wpapi : null,
  user : null,

  accountTabs : document.getElementById('accountTabs'),
  tabSavedSearches : document.querySelector('.tab.saved-searches'),
  favoriteBtns : document.querySelectorAll('.listings-grid .column .simplefavorite-button'),

  init : () => {
    wpapi.init()
    self.registerEvents()
    self.SavedSearches.init()
  },

  registerEvents : () => {
    [...self.favoriteBtns].forEach( btn => btn.addEventListener("click", self.Favorites.update) );
    self.accountTabs.addEventListener('click', self.changeTab)
  },

  changeTab : e => {
    if (e.target.nodeName !== 'BUTTON') return false
    const button = e.target
    const activeButton = self.accountTabs.querySelector('.active')
    const rel = button.getAttribute("rel")
    const selectedTab = self.container.querySelector(`.tab[rel="${rel}"]`)
    const activeTab = self.container.querySelector(`.tab.active`)

    activeButton.classList.remove("active")
    activeTab.classList.remove("active")

    button.classList.add("active")
    selectedTab.classList.add("active")
  },






  Favorites : {
    update : e => {
      const button = e.currentTarget
      const column = button.parentNode.parentNode.parentNode

      column.classList.add("fade")
      setTimeout( () => column.remove(), 750)
    }
  },








  SavedSearches : {
    data : null,

    init : () => {
      const userID = self.container.getAttribute("data-user-id")
      wpapi.wp.users().id(userID)
        .then( user => self.SavedSearches.createHtmlFrom(user))
        .catch( err => console.log(err))
      /*wpapi.wp.users().me()
        .then( user => self.SavedSearches.createHtmlFrom(user))
        .catch( err => console.log(err))*/
    },

    delete : e => {
      const btn = e.currentTarget
      const column = btn.parentNode.parentNode.parentNode
      const index = column.getAttribute("data-search-index")
      const userID = self.container.getAttribute("data-user-id")

      column.classList.add("fade")
      setTimeout( () => column.remove(), 750)

      return wpapi.deleteSearchDataFor({
        index : index,
        userID : userID
      })
    },

    createHtmlFrom : user => {
      let column, block, min, max, href, propsContainer, mod, index = 0, permalink
      self.user = user
      
      console.log(self.user);
      self.searches = (self.user.acf.saved_searches && self.user.acf.saved_searches.length) ? JSON.parse(self.user.acf.saved_searches) : []
      self.statusEL = self.tabSavedSearches.querySelector('.status')

      // If no searches, display the no results state
      if ( self.searches.length === 0 ) {
        self.statusEL.classList.remove("state__loading")
        self.statusEL.classList.add("state__noresults")
        return false
      }

      // Create an html element for each saved search
      for (let search of self.searches) {
        href = '/listings'

        propsContainer = document.createElement("div")
        propsContainer.className = 'props'

        block = document.createElement('div')
        block.className = 'search-block'
        block.innerHTML = `<span class="title">${search.name}</span>`
        block.appendChild(propsContainer)
        block.searchType = 'saved'

        column = document.createElement('div')
        column.className = 'column'
        column.setAttribute('rel', "3")
        column.setAttribute('data-search-index', index)
        column.appendChild(block)

        // Loop through the props
        for (var prop in search.params) {
          if (!search.params.hasOwnProperty(prop)) return false
          let propVal = search.params[prop]
          let propTitle = self.toTitleCase(prop.replace('_', ' '))

		  if (prop === 'type') {
			  block.searchType = propVal;
		  } else if (prop === 'permalink') {
			  permalink = propVal;
		  } else if (prop === 'id') {
          } else if (prop === 'price') {
            min = (propVal.min) ? `$${parseInt(propVal.min).toLocaleString()}` : 'None'
            max = (propVal.max) ? `$${parseInt(propVal.max).toLocaleString()}` : 'None'
            href += (propVal.min) ? `&price.min=${propVal.min}` : ''
            href += (propVal.max) ? `&price.max=${propVal.max}` : ''

            propsContainer.innerHTML += `
              <p class="prop"><span class="name">${propTitle} Min</span><span class="value">${min}</span></p>
              <p class="prop"><span class="name">${propTitle} Max</span><span class="value">${max}</span></p>
            `
          } else {
	          
		  	if (prop === 'address') block.searchType = 'saved';
			  
            href += `&${prop}=${propVal}`
            mod = (prop === 'total_bedrooms' || prop === 'total_bathrooms') ? 'num' : ''

            propsContainer.innerHTML += `
              <p class="prop ${mod}"><span class="name">${propTitle}</span><span class="value">${propVal}</span></p>
            `
          }
        }

        // Transform first & with ? to form a proper param string
        href = href.replace("/listings&", "/listings?")

        // Show the action buttons
        block.innerHTML += `
          <div class="actions">
            <button class="btnDelete"><i class="material-icons">delete</i></button>` + (block.searchType == 'saved' ?  `<a href="${href}" class="btnRun btn solid dark">Run Search</a>` : `<a href="${permalink}" class="btnRun btn solid dark">View</a>`) + `</div>`

        // Append html element to dom
        self.tabSavedSearches.querySelector('.columns').appendChild(column)

        // Increment the index
        index += 1
      }

      // Remove the loading state after everything is finished
      self.statusEL.remove()

      // Add event to all delete buttons
      const deleteSearchBtns = document.querySelectorAll('.search-block .btnDelete');
      [...deleteSearchBtns].forEach( btn => btn.addEventListener("click", self.SavedSearches.delete) );

    }
  }, // SavedSearches






  toTitleCase : str => str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})

}
